import React from 'react';
import { ViewOrder } from "../actionButtons/ViewOrder";
import { ResendInvoice } from "../actionButtons/ResendInvoice";
import {
  ORDER_STATUSES,
  ORGANIZATION_STATUSES,
  TRANSLATED_ORDER_STATUSES,
  USER_DELETE_STATUSES
} from "../../../../config/constants";
import {ViewUser} from "../actionButtons/ViewUser";
import {displayUsername} from "../../../../helpers/displayUsername";
import { RefundOrder } from '../actionButtons/RefundOrder';
import {DownloadOrder} from "../actionButtons/DownloadOrder";
import { getOrderTypeByValue } from '../../../../helpers/general';
import { CancelOrder } from '../actionButtons/CancelOrder';
import { ROUTE_CLIENT_ORDER_VIEW } from 'config/routes';
import moment from 'moment';
import { LinkResource } from '../../../../components/shared/LinkResource';
import { ROUTE_CLIENT_ORGANIZATIONS_VIEW, ROUTE_CLIENT_USER_VIEW } from '../../../../config/routes';
import { FormattedMessage } from 'react-intl';

function TableRow(props) {
  const { order, index } = props;
  if (! order) {
    return null;
  }
  const shouldDisplayUser = order.user?.id && !USER_DELETE_STATUSES.includes(order.user?.status);

  return (
    <tr>
      <td>
        <LinkResource
          displayText={order.order_number}
          resourceLink={ROUTE_CLIENT_ORDER_VIEW}
          resourceParamId={{':id': order.id}}
        />
      </td>
      <td>{order.created_at && moment(order.created_at).format('lll')}</td>
      <td>{order.neo_id && order.neo_id}</td>
      <td>{order.neo_invoice_series && order.neo_invoice_series.replaceAll(".", " ")}</td>
      <td>{order.neo_invoice_number && order.neo_invoice_number}</td>
      {
        props.shouldRenderFields ?
        <td>
          {
            shouldDisplayUser ?
            <LinkResource
              displayText={displayUsername(order.user)}
              resourceLink={ROUTE_CLIENT_USER_VIEW}
              resourceParamId={{':userId': order.user.id}}
            /> :
            <FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />
          }
        </td> : null
      }
      <td>
        {
          order.organization?.id && order.organization?.status === ORGANIZATION_STATUSES.CREATED ?
          <LinkResource
            displayText={order.organization.name}
            resourceLink={ROUTE_CLIENT_ORGANIZATIONS_VIEW}
            resourceParamId={{':organizationId': order.organization.id}}
          /> :
          <>{order.organization_name} (<FormattedMessage id="components.pages.organizations.table.tableRow.organization_deleted" />)</>
        }
      </td>
      <td className="order-status">
        {TRANSLATED_ORDER_STATUSES[order.status]}
        {order.status === ORDER_STATUSES.REFUND_ERROR ? (
          <div className="text-danger mt-1">
            <FormattedMessage id="messages.order_refund_failed" />
          </div>
        ) : null}
      </td>
      <td>{getOrderTypeByValue(order.type)}</td>
      <td>{order.refund_order_number}</td>
      <td>{order.total}</td>
      <td className="w-10">
        <ViewOrder
          order={order}
        />
        <ResendInvoice
          order={order}
          index={index}
          showIcon={true}
        />
        <RefundOrder
          order={order}
          index={index}
          actionCallback={() => props.actionCallback( true )}
        />
        <CancelOrder
          order={order}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
        {order.status === ORDER_STATUSES.PAID || order.status === ORDER_STATUSES.REFUNDED_SUCCESS? <DownloadOrder order={order} index={index}/> : null}
        {props.shouldRenderFields && order.user?.id ? <ViewUser order={order}/> : null}
      </td>
    </tr>
  )
}

export { TableRow };
